import { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from 'leaflet';
import "leaflet-ant-path";

const AntPathLayer = ({ positions, options }) => {
  const map = useMap();

  useEffect(() => {
    const antPath = L.polyline.antPath(positions, {
      color: "blue",
      weight: 5,
      pulseColor: "white",
      ...options,
    });

    map.addLayer(antPath);

    return () => {
      map.removeLayer(antPath);
    };
  }, [map, positions, options]);

  return null;
};

export default AntPathLayer;